module.exports = __webpack_public_path__ + "static/media/multiverse2.466edb53.png";